// Response shapes mirroring the route serializers in src/routes/cluster.ts.
//
// Worker rows used to live here too, in a second shape over the same database
// rows. They moved to lib/workers/types.ts with the single list endpoint.

export interface ClusterRow {
	id: string;
	name: string;
	publicHostnames: string[];
	releaseHostname: string | null;
	managerHostname: string | null;
	webroot: string;
	extraAllowedIps: string[];
	lbPolicy: "round-robin" | "least-conn" | string;
	clusterProxyEnabled: boolean;
	regionFallbacks: Record<string, string[]>;
	countryRegions: Record<string, string>;
	maxConcurrentLaunches: number;
	basicAuthRealm: string | null;
	basicAuthFile: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface ClusterStats {
	totalHosts: number;
	enabledHosts: number;
	dirty: boolean;
	/** Non-fatal geo routing config problems, e.g. a pool with no workers. */
	geoWarnings?: string[];
	lastRender: {
		id: string;
		status: string;
		finishedAt: string | null;
		exitCode: number | null;
	} | null;
}

export interface ClusterResponse {
	success: boolean;
	cluster: ClusterRow | null;
	stats: ClusterStats;
}

export interface PreviewResponse {
	success: boolean;
	current: string;
	next: string;
	diff: string;
}

export function arraysEqual(a: string[], b: string[]) {
	if (a.length !== b.length) return false;
	for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
	return true;
}
